import DepthScroller from "@components/core/DepthScroller";

import { Preview } from "./Preview";
import { config } from "./config";

const MAX = 600;
const MIN = 200;

export function ReaderAppHero() {
  const items = config.map(item => <Item key={item.publication} {...item} />);
  return <DepthScroller asset={<Preview />} items={items} />;
}

function Item({ publication }: { publication: string }) {
  const duration = Math.floor(Math.random() * MAX) + MIN;
  const progress = Math.random();
  const time = Math.floor(progress * duration);
  return (
    <div className='relative flex items-center gap-20 rounded-full bg-default p-12 shadow-lg md:p-20'>
      <img
        alt='A logo of a the type of content that can be read in the ElevenLabs Reader App'
        className='h-24 w-24 shrink-0 rounded-full object-cover md:h-48 md:w-48'
        src={publication}
      />
      <p className='f-ui-01'>{formatTime(time)}</p>
      <div className='relative h-5 w-[200px] overflow-hidden rounded-full bg-dark md:w-[350px]'>
        <div
          className='h-full bg-inverse'
          style={{
            width: `${progress * 100}%`,
          }}
        />
      </div>
      <p className='f-ui-01'>{formatTime(duration)}</p>
      <img
        alt='The Elevenlabs logo'
        className='h-24 w-24 shrink-0 rounded-full object-cover md:h-48 md:w-48'
        src='https://storage.googleapis.com/eleven-public-cdn/images/marketing/elevenlabs-avatar-white.png'
      />
    </div>
  );
}

function formatTime(seconds: number) {
  const mm = Math.floor(seconds / 60);
  const ss = seconds % 60;
  const paddedMM = mm.toString().padStart(2, "0");
  const paddedSS = ss.toString().padStart(2, "0");
  return `${paddedMM}:${paddedSS}`;
}
export default ReaderAppHero;
